import { render } from "./dictionary-set.vue?vue&type=template&id=11893414&scoped=true&ts=true"
import script from "./dictionary-set.vue?vue&type=script&lang=ts"
export * from "./dictionary-set.vue?vue&type=script&lang=ts"

import "./dictionary-set.vue?vue&type=style&index=0&id=11893414&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11893414"]])

export default __exports__